import React from "react";
import CardItem from "./CollectionCardItem";

const CollectionCardList = ({
  elements,
  isLoading,
  linkRoute,
  onSurface = false,
}) => {
  const failure = (
    <div>
      <div className="row mt15">
        <div className="col s12 center-align">Элементы не найдены</div>
      </div>
    </div>
  );

  if (!elements && !isLoading) {
    return failure;
  }
  if (elements && !isLoading) {
    if (elements.length == 0) {
      return failure;
    }
  }

  return elements.map((v, i, arr) => (
    <CardItem
      title={v.name}
      onSurface={onSurface}
      key={v.id}
      linkTo={"/" + linkRoute + "/" + v.id}
      images={v.images}
    />
  ));
};

export default CollectionCardList;
